(() => {
  const storageKey = 'silverlight-reasons-sale-deadline';

  function initializeCountdown(root) {
    const countdown = root.querySelector('[data-reasons-countdown]');
    if (!countdown || countdown.dataset.initialized === 'true') return;
    countdown.dataset.initialized = 'true';

    const duration = Number(countdown.dataset.hours || 72) * 60 * 60 * 1000;
    let deadline = Number(window.localStorage.getItem(storageKey));
    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + duration;
      window.localStorage.setItem(storageKey, String(deadline));
    }

    const hours = countdown.querySelector('[data-countdown-hours]');
    const minutes = countdown.querySelector('[data-countdown-minutes]');
    const seconds = countdown.querySelector('[data-countdown-seconds]');

    const update = () => {
      const remaining = Math.max(0, deadline - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      hours.textContent = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
    };

    update();
    window.setInterval(update, 1000);
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-silverlight-reasons]').forEach(initializeCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
